import authReducer from './slices/authSlice';
import jobPermissionsReducer from './slices/jobPermissionsSlice';
import jobsCreatedListReducer from './slices/jobCreatedListSlice';
import interviewMatchReducer from './slices/interviewMatchSlice';
import activeJobCreatedListReducer from './slices/activeJobCreatedListSlice';

export const reducers = {
  auth: authReducer,
  jobPermissions: jobPermissionsReducer,
  jobsCreatedList: jobsCreatedListReducer,
  interviewMatch: interviewMatchReducer,
  activeJobsList: activeJobCreatedListReducer,
};
